const isPromise = value => {
  if (value !== null && typeof value === "object") {
    return value && typeof value.then === "function";
  }

  return false;
};

const errorHandler = () => {};

export default function handleRejectedPromiseMiddleware() {
  return store => next => action => {
    const result = next(action);

    if (!errorHandler || !isPromise(result)) {
      return result;
    }

    return result.catch(errorHandler);
  };
}
